/**
 * 新闻资讯管理后台api
 * 新闻资讯管理后台相关接口
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The NewsPreviewUrlVo model module.
   * @module news/model/NewsPreviewUrlVo
   * @version 0.1.0
   */

  /**
   * Constructs a new <code>NewsPreviewUrlVo</code>.
   * @alias module:news/model/NewsPreviewUrlVo
   * @class
   * @param id {Integer} 新闻ID
   * @param modifiedMillis {Integer} 生成预览地址时对应的新闻修改时间毫秒值（m参数）
   * @param signature {String} 预览签名（s参数）
   */
  var exports = function(id, modifiedMillis, signature) {
    var _this = this;

    _this['id'] = id;
    _this['modifiedMillis'] = modifiedMillis;
    _this['signature'] = signature;
  };

  /**
   * Constructs a <code>NewsPreviewUrlVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:news/model/NewsPreviewUrlVo} obj Optional instance to populate.
   * @return {module:news/model/NewsPreviewUrlVo} The populated <code>NewsPreviewUrlVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'modifiedMillis')) {
        obj['modifiedMillis'] = ApiClient.convertToType(data['modifiedMillis'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'signature')) {
        obj['signature'] = ApiClient.convertToType(data['signature'], 'String');
      }
    }
    return obj;
  }

  /**
   * 新闻ID
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 生成预览地址时对应的新闻修改时间毫秒值（m参数）
   * @member {Integer} modifiedMillis
   */
  exports.prototype['modifiedMillis'] = undefined;
  /**
   * 预览签名（s参数）
   * @member {String} signature
   */
  exports.prototype['signature'] = undefined;



  export default exports;
;


